<template>
  <section class="hero is-fullheight">
    <div class="cus-padding">
      <div class="container is-mobile">
        <div class="block animated" :class="animation">
          <slot></slot>
        </div>
        </div>
    </div>
    <cham-footer/>
  </section>
</template>

<script>
  export default {
    name : "Block",
    props : ['animationClass'] ,
    data () {
      return {
        animation : ""
      }
    },
    mounted () {
      this.animation = this.animationClass
    }
  }
</script>

<style lang="scss" >

@import '../../static/_variables.scss';

.block{
  background: $accent-color;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 0.5em;
  border:$border-color 0.1em solid;
  transition: all 1s;
  -webkit-box-shadow: 10px -7px 13px 0px rgba(0,0,0,0.2);
  -moz-box-shadow: 10px -7px 13px 0px rgba(0,0,0,0.2);
  box-shadow: 10px -7px 13px 0px rgba(0,0,0,0.2);
  margin-left: 15px;
  margin-right: 15px;
}


</style>



// WEBPACK FOOTER //
// src/componests/Block.vue